import { TrendingUp, Banknote, Handshake } from "lucide-react";

const ITEMS = [
  {
    icon: TrendingUp,
    title: "Fair valuations, 3–5× earnings",
    desc:
      "We pay competitive multiples grounded in your real cash flow — not deflated valuations or trailing offers.",
  },
  {
    icon: Banknote,
    title: "Financing already secured",
    desc:
      "We come to the table with capital in place. No financing contingencies, no last-minute fall-throughs.",
  },
  {
    icon: Handshake,
    title: "A transition that respects your team",
    desc:
      "We need 3 years of P&L and tax returns to get started. From there, we move thoughtfully and confidentially.",
  },
];

export default function ValueProps() {
  return (
    <section
      data-testid="value-props-section"
      className="bg-[#E6EAE3] py-24 md:py-32 border-y border-[#D5DACF]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <span className="eyebrow">Why owners choose us</span>
          <h2 className="font-serif-display text-4xl md:text-5xl tracking-tight mt-5 text-[#1A2621]">
            A buyer who values
            <span className="italic text-[#284A3B]"> what you built.</span>
          </h2>
          <p className="mt-6 text-lg text-[#4A5D54] leading-relaxed">
            Selling a care business is not a transaction — it’s a transition.
            We structure offers and timelines to protect the people who made
            your business worth selling in the first place.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 md:gap-8">
          {ITEMS.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                data-testid={`value-prop-${idx}`}
                className="bg-[#FDFBF7] rounded-2xl p-8 border border-[#D5DACF] transition-all hover:-translate-y-1 hover:shadow-md"
              >
                <div className="w-12 h-12 rounded-full bg-[#284A3B] text-[#FDFBF7] flex items-center justify-center mb-6">
                  <Icon size={20} />
                </div>
                <h3 className="font-serif-display text-2xl text-[#1A2621] leading-snug">
                  {item.title}
                </h3>
                <p className="mt-4 text-[#4A5D54] leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
